import React from 'react';
import { ProductCard } from './ProductCard';
import { Button } from './Button';
export function FeaturedProducts() {
  const products = [{
    title: 'Daedo Gen 2 E-Trunk Protector (Hogu)',
    price: '$185.00',
    category: 'Protective Gear'
  }, {
    title: 'Daedo Gen 2 Electronic Headgear',
    price: '$145.00',
    category: 'Head Gear'
  }, {
    title: 'Daedo Electronic Foot Protector',
    price: '$65.00',
    category: 'E-Foot Gear'
  }, {
    title: 'Daedo WT Approved Hand Protector',
    price: '$35.00',
    category: 'Gloves'
  }, {
    title: 'Daedo WT Approved Shin Guard',
    price: '$42.00',
    category: 'Protective Gear'
  }, {
    title: 'Daedo WT Approved Forearm Guard',
    price: '$38.00',
    category: 'Protective Gear'
  }, {
    title: 'Daedo V-Neck Taekwondo Uniform',
    price: '$55.00',
    category: 'Uniforms'
  }, {
    title: 'Daedo Target Mitt (Double)',
    price: '$28.00',
    category: 'Training Gear'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-20">
          <div data-id="element-21">
            <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-22">
              Featured Equipment
            </h2>
            <div className="w-24 h-1 bg-red-600 mt-4" data-id="element-23"></div>
            <p className="mt-4 text-gray-600 font-medium max-w-2xl" data-id="element-24">
              Top-rated Daedo gear trusted by athletes worldwide.
            </p>
          </div>
          <Button variant="secondary" className="mt-6 md:mt-0 hidden md:inline-flex" data-id="element-25">
            Shop All Products
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-26">
          {products.map((product, index) => <ProductCard key={index} title={product.title} price={product.price} category={product.category} isNew={index < 2} data-id="element-27" />)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-28">
          <Button variant="secondary" className="w-full" data-id="element-29">
            Shop All Products
          </Button>
        </div>
      </div>
    </section>;
}